import Yotpo from "components/Layout/Yotpo";

const YotpoReviews = () => {
  return (
    <div className={"content-spacing py-16 md:py-24"}>
      <Yotpo />
      <div
        className="yotpo yotpo-main-widget"
        data-name="Literati Reviews"
        data-product-id="yotpo_site_reviews"
        data-url="https://literati.com/kids"
        data-yotpo-element-id="1"
      />
    </div>
  );
};

export default YotpoReviews;
